import React, { useState, useEffect, useRef } from 'react';
import { Button, styled } from '@mui/material';
import { Typography, List, ListItem, ListItemText } from "@mui/material";
import { taskIntro, taskSteps, buttonStartText, welcomeText } from "../locales/en";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";


const Welcome = ({ debugging }) => {
  const [message, setMessage] = useState("Welcome to the AI-Dress Designer!");
  const messageRef = useRef();

  useEffect(() => {
    messageRef.current = message;
  }, [message]);

  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/tutorial");
  };

  const handleDebugTutorial = () => {
    window.location.href = '/tutorial?uuid=' + new URLSearchParams(window.location.search).get('uuid');
  };

  const handleDebugRating = () => {
    window.location.href = '/rating?uuid=' + new URLSearchParams(window.location.search).get('uuid') + '&taskid=0&iteration=0';
  };

  const handleDebugFree = () => {
    window.location.href = '/free?uuid=' + new URLSearchParams(window.location.search).get('uuid') + '&taskid=99&iteration=0';
  };

  return (
    <div className='main'>
      <h1>{messageRef.current}</h1>
      <Typography variant="body1" component="p" sx={{ mb: 2 }}>
        {welcomeText}
      </Typography>

      {/* <List component="ol" sx={{ listStyleType: "decimal", pl: 4 }}>
        {taskSteps.map((step, index) => (
          <ListItem key={index} component="li" sx={{ display: "list-item" }}>
            <ListItemText primary={step} />
          </ListItem>
        ))}
      </List> */}
      <Button variant="contained" color="white" onClick={handleStart}>{buttonStartText}</Button>

      {debugging && <Box className="debugBox" sx={{ marginTop: '10rem' }}>
        <Typography variant="body1" component="p" sx={{ mb: 2 }}>
          Debugging Enabled
        </Typography>
        <Button variant="contained" color="white" onClick={handleDebugTutorial}>Debug Tutorial</Button><br />
        <Button variant="contained" color="white" onClick={handleDebugRating}>Debug Rating</Button><br />
        <Button variant="contained" color="white" onClick={handleDebugFree}>Debug Free Exploration</Button>
      </Box>}
    </div>
  );
};

export default Welcome;
